import { CommonModule } from '@angular/common';
import { Component, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-course-generate',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './course-generate.component.html',
  styleUrl: './course-generate.component.scss',
})
export class CourseGenerateComponent {
  stepCompleted = output<void>();
  backToSettings = output<void>();

  onBackToSettings(): void {
    this.backToSettings.emit();
  }
}
